var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartPulse = function SvgHeartPulse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "heart-pulse_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h48v48H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#heart-pulse_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#004152"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.588 7.588A12.25 12.25 0 0 1 14.25 4c1.885 0 3.564.269 5.194.979 1.316.573 2.549 1.411 3.806 2.546 1.257-1.135 2.49-1.973 3.806-2.546C28.686 4.269 30.365 4 32.25 4A12.25 12.25 0 0 1 44.5 16.25c0 5.145-3.394 8.972-6.37 11.888L24.133 42.134a1.25 1.25 0 0 1-1.768 0L8.374 28.14C5.368 25.235 2 21.412 2 16.25a12.25 12.25 0 0 1 3.588-8.662ZM14.25 6.5a9.75 9.75 0 0 0-9.75 9.75c0 4.034 2.626 7.208 5.619 10.101l.015.015L23.25 39.482l13.125-13.125C39.358 23.434 42 20.262 42 16.25a9.75 9.75 0 0 0-9.75-9.75c-1.635 0-2.956.231-4.196.771-1.248.544-2.491 1.434-3.92 2.863a1.25 1.25 0 0 1-1.768 0c-1.429-1.429-2.672-2.32-3.92-2.863-1.24-.54-2.561-.771-4.196-.771Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.17 15.002a1.25 1.25 0 0 1 1.229.756L31.074 22h9.716a1.25 1.25 0 1 1 0 2.5H30.25c-.5 0-.952-.298-1.149-.758l-1.615-3.768-3.034 10.62a1.25 1.25 0 0 1-2.344.164l-2.954-6.645a1.25 1.25 0 0 1-.904.387H5.69a1.25 1.25 0 1 1 0-2.5h11.787l.655-1.309a1.25 1.25 0 0 1 2.26.051l2.602 5.854 3.054-10.69a1.25 1.25 0 0 1 1.123-.904Z"
  }))));
};
export default SvgHeartPulse;